export enum HttpMethodEnum {
    Post = 'POST',
    Put = 'PUT',
    Delete = 'DELETE'
}
